export const adrenalglandModuleOverview = [
  {
    id: "anatomy",
    title: "Adrenal Gland Anatomy: Part 1",
    description: "Learn the structure of the adrenal gland",
    icon: "❤️",
    customImage: "module-adrenalgland-anatomy.png",
    gradient: "from-yellow-900 via-green-50 to-rose-100 border-yellow-800",
  },
  {
    id: "anatomy2",
    title: "Adrenal Gland Anatomy: Part 2",
    description: "Relations, lymphatics and innervation",
    icon: "❤️",
    customImage: "module-adrenalgland-anatomy.png",
    gradient: "from-yellow-900 via-green-50 to-rose-100 border-yellow-800",
  },
  {
    id: "histology",
    title: "Adrenal Gland Histology",
    description: "Microscopic structure of the adrenal gland",
    icon: "🔬",
    customImage: "module-adrenalgland-histology.png",
    gradient: "from-yellow-900 via-green-50 to-rose-100 border-yellow-800",
  },
  {
    id: "physiology",
    title: "Adrenal Gland Physiology",
    description: "Function and hormone production",
    icon: "⚡",
    gradient: "from-yellow-900 via-green-50 to-rose-100 border-yellow-800",
  },
  {
    id: "diseases",
    title: "Adrenal Gland: Diseases",
    description: "Cushing's, CAH, Waterhouse-Friderichsen and more",
    icon: "🏥",
    customImage: "module-adrenalgland-anatomy.png",
    gradient: "from-yellow-900 via-green-50 to-rose-100 border-yellow-800",
  },
  {
    id: "pharmacology",
    title: "Adrenal Gland: Pharmacology",
    description: "Glucocorticoids, aldosterone antagonists, steroidogenesis inhibitors and phaeochromocytoma drugs",
    icon: "💊",
    gradient: "from-yellow-900 via-green-50 to-rose-100 border-yellow-800",
  },
  {
    id: "surgery",
    title: "Adrenal Gland Surgery: Part 1",
    description: "Indications, adrenal incidentaloma pathway, surgical approaches & structures at risk",
    icon: "🏥",
    gradient: "from-amber-400 via-orange-50 to-yellow-200 border-amber-400",
  },
  {
    id: "surgery2",
    title: "Adrenal Gland Surgery: Part 2",
    description: "Pre-operative preparation, post-operative outcomes, bilateral adrenalectomy, Nelson's syndrome & ACC management",
    icon: "🏥",
    gradient: "from-amber-400 via-orange-50 to-yellow-200 border-amber-400",
  },
];
